import { render } from "./DebitForm.vue?vue&type=template&id=4c525ab2"
import script from "./DebitForm.vue?vue&type=script&lang=js"
export * from "./DebitForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__